<template>
  <div class="rich-text-div">
    <div v-html="row.body" class="html-content"></div>
    <div class="file-div" v-if="row.src_name">
      <List size="small">
        <ListItem>
          <ListItemMeta
            :title="$t('Appendix') + $t('alipay_name')"
            :description="row.src_name"
          />
          <template slot="action">
            <Button
              type="success"
              style="margin-right: 5px"
              size="small"
              @click="preview(1, row.src)"
            >
              {{ $t("preview") }}
            </Button>
            <Button
              type="warning"
              size="small"
              style="margin-right: 5px"
              @click="preview(null, row.src)"
            >
              {{ $t("export") }}
            </Button>
            <Button
              v-if="row.bill_status != 9"
              type="error"
              size="small"
              @click="send"
            >
              {{ $t("send") }}
            </Button>
          </template>
        </ListItem>
      </List>
    </div>
  </div>
</template>

<script>
import { sendEmail } from "@/api/finance/summary_bill";
export default {
  props: {
    row: {
      type: Object
    }
  },
  methods: {
    preview(type, src) {
      if (type) {
        window.open(
          // "https://view.officeapps.live.com/op/view.aspx?src=" +
            this.$globalUrl +
            src
        );
      } else {
        window.open(this.$globalUrl + src, "_black");
      }
    },
    send() {
      this.$Modal.confirm({
        title: this.$t("whether") + this.$t("send") + this.$t("email"),
        width: 300,
        onOk: async () => {
          console.log(this.row);
          const res = await sendEmail({
            ids: [this.row.id]
          });
          this.$Message[res.data.status ? "success" : "error"]({
            background: true,
            content: res.data.msg
          });
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.rich-text-div {
  height: 700px;
  position: relative;
}
.html-content {
  height: 620px;
  overflow: auto;
  padding-bottom: 10px;
}
.file-div {
  position: absolute;
  bottom: 0;
  width: ~"calc(100% - 30px)";
  margin: 0 30px 0 10px;
  border: 2px solid black;
  padding: 0 10px;
}
</style>
